module.exports = __webpack_public_path__ + "img/loginleftbj.png";